import { Injectable } from '@angular/core';

import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback

@Injectable({
  providedIn: 'root',
})
export class JobcardService {
  private apiURL: string = '';
  private env: any;
  private apiURLNew: string = '';
  private apiKey: string = '';

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService,
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.apiURL = this.appConfig.getEnvironment();
    this.env = this.appConfig.getEnvironmentNew();
    this.apiURLNew = this.appConfig.getEnvironmentNew().url;
    this.apiKey = this.appConfig.getApiKey();
  }

  getJobCard(jobCardID: string) {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(this.apiURL + '/api/ServiceRequest/' + jobCardID, requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getFullJobCard(ServiceID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.apiURLNew + `/Service/Jobcard/${ServiceID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getFullJobCards(ServiceID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.apiURLNew}/V2/Services/Jobcards/List?code=${this.env.key}&ServiceID=${ServiceID}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getFullJobCardsV1(ServiceID, PartnerID, CustomerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.apiURLNew}/V3/Services/Jobcards/List?code=${this.env.key}&ServiceID=${ServiceID}&PartnerID=${PartnerID}&CustomerID=${CustomerID}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getJobCardLineItems(serviceID: string) {
    return this.http
      .get(
        this.env.url + `/Service/${serviceID}/LineItems?code=${this.env.key}`,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getJobCardLineItemsV1(serviceID: string, partnerID: string) {
    return this.http
      .get(
        this.env.url + `/Service/${serviceID}/${partnerID}/LineItems?code=${this.env.key}`,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  postApproveLineItems(data) {
    return this.http
      .post(this.env.url + `/Services/Approve?code=${this.env.key}`, data, {})
      .pipe(
        map((res: any) => res),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  cancelJobCard() {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(this.apiURL + '/api/ServiceRequest/GetInvoice', requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getJobCardQRIdentifier(ServiceID) {
    const headers = this.helpersService.getNewApiHeaders();

    return this.http
      .get(
        this.apiURLNew +
        `/Service/QRCodeIdentifier/${ServiceID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getJobCardAttachments(ServiceID, QRCodeIdentifier: any = null) {
    const headers = this.helpersService.getNewApiHeaders();

    return this.http
      .get(
        this.apiURLNew +
        `/Service/Attachments/${ServiceID}?code=${this.env.key}` +
        (QRCodeIdentifier ? `&QRCodeIdentifier=${QRCodeIdentifier}` : ''),
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getJobCardAttachmentsV1(ServiceID, CustomerID, PartnerID, QRCodeIdentifier: any = null) {
    const headers = this.helpersService.getNewApiHeaders();

    return this.http
      .get(
        this.apiURLNew +
        `/Service/Attachments/${ServiceID}/${CustomerID}/${PartnerID}?code=${this.env.key}` +
        (QRCodeIdentifier ? `&QRCodeIdentifier=${QRCodeIdentifier}` : ''),
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }
  deleteJobCardAttachment(AttachmentID, QRCodeIdentifier: any = null) {
    const headers = this.helpersService.getNewApiHeaders();

    return this.http
      .delete(
        this.apiURLNew +
        `/Service/Attachment/${AttachmentID}?code=${this.env.key}` +
        (QRCodeIdentifier ? `&QRCodeIdentifier=${QRCodeIdentifier}` : ''),
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  addJobCardAttachment(data, QRCodeIdentifier: any = null) {
    const headers = this.helpersService.getNewApiHeaders();

    return this.http
      .post(
        this.apiURLNew +
        `/Service/Attachment?code=${this.env.key}` +
        (QRCodeIdentifier ? `&QRCodeIdentifier=${QRCodeIdentifier}` : ''),
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateJobCardAttachment(data: any) {
    const headers = this.helpersService.getNewApiHeaders();

    return this.http
      .put(
        this.apiURLNew + `/Service/Attachment?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  canJobCardMove(PartnerID, ServiceID) {
    if (PartnerID == null || PartnerID == undefined) {
      return throwError('Partner not set');
    }

    const headers = this.helpersService.getNewApiHeaders();

    return this.http
      .get(
        this.apiURLNew +
        `/Bikeshop/${PartnerID}/Service/${ServiceID}/CanMove?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  canJobCardBeCompleted(PartnerID, ServiceID) {
    if (PartnerID == null || PartnerID == undefined) {
      return throwError('Partner not set');
    }

    const headers = this.helpersService.getNewApiHeaders();

    return this.http
      .get(
        this.apiURLNew +
        `/Bikeshop/${PartnerID}/Service/${ServiceID}/CanBeCompleted?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getOtherShopTechnicianList(PartnerID) {
    const headers = this.helpersService.getNewApiHeaders();

    return this.http
      .get(
        this.apiURLNew +
        `/Bikeshop/${PartnerID}/Technicians?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  moveJobCard(data) {
    const headers = this.helpersService.getNewApiHeaders();

    return this.http
      .post(
        this.apiURLNew + `/Bikeshop/Jobcard/Move?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getJobcardTransferInfo(ServiceID) {
    const headers = this.helpersService.getNewApiHeaders();

    return this.http
      .get(
        this.apiURLNew +
        `/Bikeshop/Service/${ServiceID}/TransferInfo?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  postServiceRating(data: any) {
    const headers = this.helpersService.getNewApiHeaders();

    return this.http
      .post(
        this.apiURLNew + `/Services/Ratings?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => res),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  postServiceRatingAnonymous(serviceLogID, data: any) {
    const headers = this.helpersService.getNewApiHeaders();

    return this.http
      .post(
        this.apiURLNew +
        `/Services/Ratings/${serviceLogID}?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => res),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getJobCardsToLink(PartnerID, ServiceID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.apiURLNew +
        `/v4.0/${PartnerID}/jobcardsToLink/${ServiceID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getLinkJobCard(PartnerID, ServiceID, LinkServiceID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.apiURLNew +
        `/v4.0/${PartnerID}/jobcards/${ServiceID}/linkTo/${LinkServiceID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  setFavouriteLinkedServiceCustomer(PartnerID, ServiceID, UserID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.apiURLNew +
        `/store/${PartnerID}/LinkedServiceJobs/${ServiceID}/${UserID}?code=${this.env.key}`,
        {},
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
      );
  }

  checkIfJobcardMustDisconnectFromPOS(jobcardID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.apiURLNew +
        `/v4.0/POS/Lightspeed/CompletedSales/${jobcardID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  generateTinyURL(url) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.apiURLNew +
        `/Bikeshop/GetTinyURL?url=${encodeURIComponent(url)}&code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getServiceNotes(partnerID: number, serviceID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.apiURLNew}/Portal/Workshop/${partnerID}/JobCard/${serviceID}/Notes?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => res),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  addUpdateServiceNotes(data) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        `${this.apiURLNew}/Portal/Workshop/JobCard/Note?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => res),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  deleteServiceNote(partnerID: number, serviceID: number, noteID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        `${this.apiURLNew}/Portal/Workshop/${partnerID}/JobCard/${serviceID}/Note/${noteID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => res),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getActiveJobCardTimers(partnerID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.apiURLNew}/Portal/Workshop/${partnerID}/ActiveServiceTimers?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => res),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getServiceSpecificTimers(partnerID: number, serviceID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.apiURLNew}/Portal/Workshop/${partnerID}/JobCard/${serviceID}/ServiceTimers?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => res),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  startServiceTimer(partnerID: number, serviceID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        `${this.apiURLNew}/Portal/Workshop/${partnerID}/JobCard/${serviceID}/ServiceTimer/Start?code=${this.env.key}`,
        null,
        headers
      )
      .pipe(
        map((res: any) => res),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }


  stopServiceTimer(partnerID: number, serviceID: number, timerID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        `${this.apiURLNew}/Portal/Workshop/${partnerID}/JobCard/${serviceID}/ServiceTimer/${timerID}/Stop?code=${this.env.key}`,
        null,
        headers
      )
      .pipe(
        map((res: any) => res),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  pauseServiceTimer(partnerID: number, serviceID: number, timerID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        `${this.apiURLNew}/Portal/Workshop/${partnerID}/JobCard/${serviceID}/ServiceTimer/${timerID}/Pause?code=${this.env.key}`,
        null,
        headers
      )
      .pipe(
        map((res: any) => res),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getJobcardAudit(partnerID: number, serviceID: number) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        `${this.apiURLNew}/workshop/${partnerID}/job/${serviceID}/audit?code=${this.env.key}`,
        headers
      )
      .pipe(
        map((res: any) => res),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

}
